import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SigninButton from './SigninButton/SigninButton';
import UserProfile from './UserProfile/UserProfile';
import MenuCard from './MenuCard/MenuCard';
import Logo from '../Logo/Logo';
import Restart from './Restart';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@asgardeo/auth-react';

const Header = ({ showLogo = true, showMenu = true, currentViewState }) => {
  const navigate = useNavigate();
  const { state } = useAuthContext();
  const [currentPage, setCurrentPage] = useState('home');
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  const handleLogoClick = () => {
    if (currentViewState === 'result') {
      // Show confirmation popup when in result view
      setShowConfirmPopup(true);
    } else {
      // Normal navigation for other views
      navigate('/');
    }
  };

  const handleCloseRestart = () => {
    setShowConfirmPopup(false);
  };

  return (
    <>
      <div
        className={`${
          currentPage === 'home'
            ? 'bg-pl_bg_light_3 dark:bg-pl_bg_dark_1'
            : 'bg-pl_bg_light_1 dark:bg-pl_bg_dark_3'
        } w-full z-[100] sticky top-0 border-b border-pl_border_light_1 dark:border-pl_border_dark_1 shadow-sm`}
      >
        {/* Header Row */}
        <div className="flex items-center justify-between p-4 px-10 md:px-20">
          {/* Left: Logo */}
          {showLogo && (
            <div className="flex items-center">
              <button
                onClick={handleLogoClick}
                className="flex items-center gap-2"
              >
                <Logo small />
              </button>
            </div>
          )}

          {showMenu && (
            <div className="flex gap-3 items-center">
              <MenuCard />
              {state.isAuthenticated ? <UserProfile /> : <SigninButton />}
            </div>
          )}
        </div>
      </div>

      {/* Restart Confirmation Popup */}
      <Restart 
        isOpen={showConfirmPopup}
        onClose={handleCloseRestart}
      />
    </>
  );
};

Header.propTypes = {
  showLogo: PropTypes.bool,
  showMenu: PropTypes.bool,
  currentViewState: PropTypes.string,
};

export default Header;
